import GridTile from "../grid/GridTile";
import { TileTypeRarity } from "../grid/TileTypeRarity";
import Sprite from "./Sprite";

export default class OreSpriteOverlay {
    constructor() {
        /**
         * @constant
         * @type {Array.<Sprite[]>}
         */
        this.oreSpriteLists = [];
    }

    /**
     * 
     * @param {Sprite[]} oreSprites 
     */
    addSeries(oreSprites) {
        this.oreSpriteLists.push(oreSprites);
    }

    /**
     * 
     * @param {GridTile} tile 
     * @returns {Sprite}
     */
    getOreSprite(tile) {
        if (!tile || tile.open) {
            return null;
        }

        if (tile.tileType.rarityModifier !== TileTypeRarity.ORE) {
            return null;
        }

        const row = tile.getTileRow();
        //////const worldRows = Settings.grid.worldTileHeight;
        const worldRows = 10000;

        const ratio = Math.min(0.999, row / worldRows);

        const listIndex = (this.oreSpriteLists.length * ratio) | 0;

        const spriteList = this.oreSpriteLists[listIndex];

        // We always want to use the same ore sprite for a tile. Use the tile hash to choose the sprite.
        return spriteList[tile.hash() % spriteList.length];
    }

}